import { Routes } from '@angular/router';

import { TrialsComponent } from './trials/trials.component';
import { SectionOverviewComponent } from './section-overview/section-overview.component';
import { BatchWeighingComponent } from './batch-weighing/batch-weighing.component';
import { AdminComponent } from './admin/admin/admin.component';
import { MsalGuard } from '@azure/msal-angular';
import { EditTrialComponent } from './admin/edit-trial/edit-trial.component';
import { SyncComponent } from './sync/sync.component';
import { RemovalsComponent } from './removals/removals.component';

export class RoutePaths {
  public static TRIALS: string = 'trials';
  public static SECTION_OVERVIEW: string = 'section-overview';
  public static BATCH_WEIGHING: string = 'batchweighing';
}

export const titleName = 'Xreg - ';

export const routes: Routes = [
  {
    path: '',
    canActivateChild: [MsalGuard],
    children: [
      {
        path: 'admin',
        component: AdminComponent,
        title: titleName + 'Admin',
      },
      {
        path: 'admin/edit-trial',
        component: EditTrialComponent,
        title: titleName + 'Rediger afprøvning',
      },
      {
        path: 'batchweighing/:id',
        component: BatchWeighingComponent,
        title: titleName + 'Indsættelsesvejning',
      },
      {
        path: 'trials',
        component: TrialsComponent,
        title: titleName + 'Afprøvninger',
      },
      {
        path: 'removals',
        component: RemovalsComponent,
        title: titleName + 'Udtagning',
      },
      {
        path: 'sync',
        component: SyncComponent,
        title: titleName + 'Sykronisering',
      },
      {
        path: 'section-overview/:sectionId',

        component: SectionOverviewComponent,
        title: titleName + 'Sektionsoverblik',
      },
      {
        path: '**',
        redirectTo: 'trials',
      },
    ],
  },
];
